// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__IDcV8","nav":"Sidebar_nav__wGroV","open":"Sidebar_open__k4gZm","native":"Sidebar_native__HlX-2"};